import { Injectable } from '@angular/core';
import { AccessToken } from '@okta/okta-auth-js';
import { BehaviorSubject, Observable } from 'rxjs';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class IamService {
  private errorObtainingPermissions: BehaviorSubject<boolean>;
  private obtainingPermissions: BehaviorSubject<boolean>;
  private permission: BehaviorSubject<any>;

  constructor(private api: BaseApiService) {
    this.errorObtainingPermissions = new BehaviorSubject<boolean>(false);
    this.obtainingPermissions = new BehaviorSubject<boolean>(false);
    this.permission = new BehaviorSubject<any>(null);
  }

  isObtainingPermission(): Observable<boolean> {
    return this.obtainingPermissions.asObservable();
  }

  hasErrorObtainingPermission(): Observable<boolean> {
    return this.errorObtainingPermissions.asObservable();
  }

  userPermission(): Observable<any> {
    return this.permission.asObservable();
  }

  getUserIAM(token: AccessToken) {
    this.obtainingPermissions.next(true);
    this.errorObtainingPermissions.next(false);
    const baseUrl = window.location.origin;
    const url = baseUrl + '/api/iam/GetPermissions';
    this.api.headerToken = token.accessToken;
    const t = this.api.get<string>(url);
    t.then(r => {
      this.obtainingPermissions.next(false);
      if (r == null) {
        this.errorObtainingPermissions.next(true);
      } else {
        this.permission.next(JSON.parse(r));
      }
    });
  }
}
